// extracted by mini-css-extract-plugin
export var aiButton = "recipe-ingredient-module--ai-button--f97d8";
export var changeBox = "recipe-ingredient-module--changeBox--16e2d";
export var changeButton = "recipe-ingredient-module--change-button--afc54";
export var content = "recipe-ingredient-module--content--43d07";
export var dropdown = "recipe-ingredient-module--dropdown--332e7";
export var replacement = "recipe-ingredient-module--replacement--46f91";
export var replacementButton = "recipe-ingredient-module--replacement-button--4a39a";
export var simple = "recipe-ingredient-module--simple--404a6";
export var wrapper = "recipe-ingredient-module--wrapper--319b3";